import React from 'react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import boardsImgSVG from './assets/boards-directory-app-skeleton.tpl.svg';
import dashboardsImgSVG from './assets/dashboards-directory-app-skeleton.tpl.svg';
import filtersImgSVG from './assets/filters-directory-app-skeleton.tpl.svg';
import projectsImgSVG from './assets/projects-directory-app-skeleton.tpl.svg';

export const BoardsDirectorySkeleton = (): React.JSX.Element => (
	<AppSkeletonImage src={boardsImgSVG} />
);

export const DashboardsDirectorySkeleton = (): React.JSX.Element => (
	<AppSkeletonImage src={dashboardsImgSVG} />
);

export const FiltersDirectorySkeleton = (): React.JSX.Element => (
	<AppSkeletonImage src={filtersImgSVG} />
);

export const ProjectsDirectorySkeleton = (): React.JSX.Element => (
	<AppSkeletonImage src={projectsImgSVG} />
);

// TODO: update with a proper SVG image
export const PlansDirectorySkeleton = (): React.JSX.Element => (
	<AppSkeletonImage src={projectsImgSVG} />
);
